module.exports = __webpack_public_path__ + "img/어벤져.77b1596d.png";